import $ from 'jquery'
function reseize() {
    if (window.innerWidth < 1280) {
        document.documentElement.style.fontSize = '66.6px';
        return;
    }

    let designSize = 1920; // 设计图尺寸
    let html = document.documentElement;
    let wW = html.clientWidth;// 窗口宽度
    let rem = wW * 100 / designSize;
    document.documentElement.style.fontSize = rem + 'px';
}

$(function () {
    reseize()
    $(window).resize(reseize);
})
